import React from "react";
import { useDispatch } from "react-redux";
import appStateSlice from "../../store/appState/appStateSlice";

const Tabs = (props) => {
    const dispatch = useDispatch();
    const setTab = (item) => {
        dispatch(appStateSlice.actions.setActiveTab(item));
    };

    return (
        <div className="tabs">
            {props.tabs && props.tabs.map(item => {
                let isActive = props.activeTab === item.name ? " active" : "";
                return <div className={`${item.isDisable ? "disabled-tab" : ""} tab-wrap` + isActive} onClick={() => setTab(item.name)} key={"tab-" + item.name}>
                    <div className="tab-item" id={item.name} key={"tabs-" + item.name}>{item.name} {item.isDisable && <span className="tab-lock-icon"></span>}</div>
                </div>;
            })
            }
        </div>
    );
};

export default Tabs;